import { usageMap, goalMap, featureMap } from '../data';
import get from 'lodash/get';

export default {
	getUsage: () => (slug) => {
		return usageMap.find((f) => slug === get(f, 'slug'));
	},
	getGoal: () => (slug) => {
		return goalMap.find((f) => slug === get(f, 'slug'));
	},
	goalDescription: (state, getters, rootState, rootGetters) => {
		const goal = getters.getGoal(rootGetters.onboardingGoal);
		return get(goal, 'title') || '';
	},
	featureMap: () => featureMap,
	getFeature: () => (slug) => {
		return featureMap.find((f) => slug === get(f, 'slug'));
	},
	features: (state, getters) => {
		return state.extraFeatures.map((f) => getters.getFeature(f));
	},
	proFeatures(state, getters) {
		return getters.features.filter((f) => !get(f, 'plugin'));
	},
	getFeatureProp: (state, getters) => (slug, property) => {
		const feature = getters.getFeature(slug);
		return get(feature, property) || false;
	},
	inExtraFeatures: (state) => (value) => {
		return state.extraFeatures && -1 !== state.extraFeatures.indexOf(value);
	},
};
